import React from 'react';
import { apiGetPhoto, apiGetTestPhoto, apiGetTestPhotoList, apiIsLoggedIn } from "../api/api";


class TestPhotoPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoggedIn: false,
            imageUrls: null,
        }
    }

    async componentDidMount() {
        const isLoggedIn = await apiIsLoggedIn();
        if (!isLoggedIn) {
            window.location.href = '/';
        }

        const photoListResponse = await apiGetTestPhotoList();
        if (photoListResponse.ok) {
            const photoListResponseJson = await photoListResponse.json();

            const promises = [];
            const imageUrls = [];

            photoListResponseJson.photo_list.forEach((uri) => {
                promises.push(apiGetPhoto(uri));
            });

            const photoResponses = await Promise.allSettled(promises);
            const blobPromises = [];

            photoResponses.forEach((response) => {
                if (response.value.ok) {
                    const streamResponse = new Response(response.value.body);
                    blobPromises.push(streamResponse.blob());
                }
            });

            const blobs = await Promise.allSettled(blobPromises);
            blobs.forEach((imageBlob) => {
                const imageObjectURL = URL.createObjectURL(imageBlob.value);
                imageUrls.push(imageObjectURL);
            });

            this.setState({
                ...this.state,
                imageUrls: imageUrls,
            });
        }
    }

    render() {
        return (
            <div>
                {this.state.imageUrls ? this.state.imageUrls.map((imageUrl) => {
                    return (<img src={imageUrl}/>);
                }) : <p>Loading</p>}
            </div>
        )
    }
}

export default TestPhotoPage;
